import React from "react";
import { connect } from 'react-redux';
import {
  Grid,
  Image
} from "semantic-ui-react";
import {
  DateTimeInput,
} from 'semantic-ui-calendar-react';
import moment from 'moment';
import './css/TimeOfDeparturePicker.css';
import {
  setDateTime,
  fetchRoute,
} from '../actions/interactionActions';

import time from '../images/timeOfDeparturePicker/time.svg';

class TimeOfDeparturePicker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dateTime: '',
    };
  }

  handleChange = (event, { name, value }) => {
    this.setState({dateTime: value});

    /**
     * Dirty implementation; HERE documentation doesn't state how to
     * add timezone information and RFC 3339 fornat does not seem to work.
     * Through this workaround, we cut off timezone information; HERE maps
     * assumes the according to locale.
     */
    let sliced = moment(value, 'HH:mm, DD.MM.y').format().slice(0, 19);
    this.props.setDateTime(sliced);

    try {
      this.props.fetchRoute(this.props.startCoordinates, this.props.destinationCoordinates, sliced);
    } catch(error) {
      console.log(error);
    }
  }

  render() {
    return (
      <Grid.Row style={{ paddingBottom: '0px', paddingTop: '0px' }}>
        <Grid.Column width={3} >
          <Image src={time}  width='24px' spaced='left' />
        </Grid.Column>
        <Grid.Column width={9} style={{paddingLeft: 0}}>
          <DateTimeInput
            id='dateTime'
            name='dateTime'
            placeholder='Jetzt losfahren'
            value={this.state.dateTime}
            icon='dropdown'
            onChange={this.handleChange}
            fluid
            dateTimeFormat='HH:mm, DD.MM.y'
            startMode={'hour'}
            closable
            preserveViewMode={false}
            hideMobileKeyboard={true}
            closeOnMouseLeave={false}
            minDate={new Date()}
          />
        </Grid.Column>
      </Grid.Row>
    );
  }
}

const mapStateToProps = state => ({
  startCoordinates: state.posts.startCoordinates,
  destinationCoordinates: state.posts.destinationCoordinates,
});

export default connect(mapStateToProps, { setDateTime, fetchRoute })(TimeOfDeparturePicker)